import { Box, Flex, Text } from "@chakra-ui/react";
import { GCSmallLogoIcon } from "../../components/icons/GCSmallLogoIcon";
import { Link } from "react-router-dom";

interface ValkyraeFooterProps {
  isMobileBreakpoint: boolean;
}

export function ValkyraeFooter({ isMobileBreakpoint }: ValkyraeFooterProps) {
  return (
    <Flex direction="column" gap="40px" width="100%" alignItems="center">
      <Box width="100%" height="1px" background="transparent.white.10" />
      <Flex width="100%" justifyContent="flex-start" gap="32px">
        <GCSmallLogoIcon width="44px" height="auto" color="blaze.blaze" />
        <Flex flex="1" flexWrap="wrap" justifyContent="space-between">
          <Text
            color="neutral.500"
            fontSize="16px"
            lineHeight="40px"
            whiteSpace="nowrap"
            justifyContent="space-between"
          >
            @ 2019 - {new Date().getFullYear()} GlobalComix
          </Text>
          <Flex gap={isMobileBreakpoint ? "8px" : "42px"} flexWrap="wrap">
            <Link
              to="/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Text
                color="neutral.500"
                fontSize="16px"
                lineHeight="40px"
                _hover={{ textDecoration: "underline" }}
                whiteSpace="nowrap"
              >
                Privacy Policy
              </Text>
            </Link>
            <Link
              to="/terms-of-use"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Text
                color="neutral.500"
                fontSize="16px"
                lineHeight="40px"
                _hover={{ textDecoration: "underline" }}
                whiteSpace="nowrap"
              >
                Terms of Service
              </Text>
            </Link>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
}